/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import { Component, OnInit } from '@angular/core'
import { UserSessionService } from '../../services/user-session.service'
import { Router } from '@angular/router'
import { AuthService } from '../../services/auth/auth.service'

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.less'],
})
export class MenuComponent implements OnInit {
    constructor(private authService: AuthService, private Session: UserSessionService, private router: Router) {}

    ngOnInit(): void {}

    authenticated() {
        return this.authService.authenticated()
    }
    // Check to see if the user is authorized to do this thing...
    authorized(feature: any) {
        return this.authService.authorized(feature)
    }

    greeting() {
        if (this.Session.crmAccounts && 0 < this.Session.crmAccounts.length) {
            return ' Hello, '
        }
        return ''
    }
    subjectDisplayName() {
        if (this.Session.crmAccounts && 0 < this.Session.crmAccounts.length) {
            return this.Session.crmAccounts[0].subject.displayName || 'USER'
        }
        return 'USER'
    }

    logout() {
        let vm = this
        vm.authService.logout().then(function () {
            // Go back to the homepage after a logout.
            vm.router.navigate(['app/login'])
        })
    }
}
